export class DatatableButton {
  public id: string;
  public action: <T>(obj: T) => void;
  public showIf?: <T>(obj: T) => boolean;
  public label?: string;
  public icon?: string;
  public classes?: string;
}



// WEBPACK FOOTER //
// ./src/app/models/datatable-button.ts